import { render, staticRenderFns } from "./a-order-minimum-warning.vue?vue&type=template&id=12222a91&scoped=true&"
import script from "./a-order-minimum-warning.vue?vue&type=script&lang=js&"
export * from "./a-order-minimum-warning.vue?vue&type=script&lang=js&"
import style0 from "./a-order-minimum-warning.vue?vue&type=style&index=0&id=12222a91&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12222a91",
  null
  
)

export default component.exports